import React from 'react';
import {Link} from "react-router-dom";
import defaultAgentAvatar from "../../../assets/img/nophoto.png";
import {connect} from "react-redux";
import {
    actionGetAllPropertyList,
    addToLikeProperty,
    addToUnLikeProperty,
    removeToLikeProperty
} from "../../../actions/propertysAction";



const PropertyListCard = ({index,id,likes,subcategory_name,property_img,property_price,property_title,property_bedroom,property_city_name,property_country_name,property_carpet_area,property_super_area,property_list_date,property_owner_name,property_state_name,agent_avatart,addToLikeProperty,addToUnLikeProperty,actionGetAllPropertyList,likePropertyLoader,unlikePropertyLoader,user,property_type,myPorperty}) => {
    return (
        <div className="card">

                <div className="float-left">
                    <div className="property-category">
                    <p>{subcategory_name?subcategory_name:''}</p>
                    </div>
                </div>
            <div className="float-right">
                {myPorperty ?
                    <div className="dropdown show action-btn update-drop">
                        <a className=" dropdown-toggle" href="#" role="button" id="dropdownMenuLink"
                           data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i className="fa fa-ellipsis-v" aria-hidden="true"/>
                        </a>

                        <div className="dropdown-menu update-mainu" aria-labelledby="dropdownMenuLink">
                            <Link className="dropdown-item" to={`/update-property/${id}`}>Update</Link>

                        </div>
                    </div>
                    :
                    <Link  to={`/new-property-details/${id}`} style={{zIndex:'9'}}>
                <div className="property-user-avatar rounded-circle">
                <img src={agent_avatart?agent_avatart:defaultAgentAvatar} className="rounded-circle"
                     alt="propertyImages"/>
                </div> </Link>}
            </div>
                {property_type&&property_type ==="PRIVATE" &&
                <div className="custom-text-color1 is-private"><i className="far fa-lock-alt"></i></div>}
            <img src={property_img} alt="Property Image"/>



            {/*</Link>*/}
            <Link to={`/new-property-details/${id}`} style={{zIndex:'9'}} >
            <div className="card-body  p-2">
                <h6 className="ml-2">{property_title ?property_title:'title'}</h6>

                <p className="p-0 m-0"><i className="fas fa-map-marker-alt mr-1 custom-text-color1"/>
                    {`${property_city_name ? ` ${property_city_name},` : ''}`}
                    {`${property_state_name ? ` ${property_state_name},` : ''}`}
                    {`${property_country_name ? ` ${property_country_name},` : ''}`}
                </p>
                <p className="p-0 m-0">
                <i className="far fa-brackets mr-1 custom-text-color1"/>
                    <strong>Carpet
                        Area:-</strong>{property_carpet_area}
                </p>
                <p className="p-0 m-0">
                    <i className="far fa-brackets mr-1 custom-text-color1"/>
                    <strong>Super
                    Area:-</strong>{property_super_area}</p>
                {property_bedroom &&  <p className="p-0 m-0"><i className="fas fa-th-large mr-1 custom-text-color1"/>{property_bedroom}BHK,</p>}
                <div className="d-flex align-items-center justify-content-between posted">
                    {/*<p className="custom-text-color1">*/}
                        {/*<strong className="custom-text-color2">{subcategory_name?subcategory_name:''}</strong></p>*/}
                <p className="p-0 m-0">
                    <strong>Posted:-</strong>{property_list_date?property_list_date:''}</p>

                </div>
            </div>
            </Link>
            <div className="card-footer  d-flex align-items-center justify-content-between">
                <div>
                    <span>{likes && likes.length ? likes.length : 0}</span>
                    {
                        likes && likes.find(like => like.user === user._id) ?
                            <span className="mx-2 h5"><i className="fas fa-thumbs-up text-primary cursor-pointer" onClick={()=>!unlikePropertyLoader&&addToUnLikeProperty(id,user._id)}/></span>
                            :
                            <span className="mx-2 h5"><i className="fas fa-thumbs-up cursor-pointer" onClick={()=>!likePropertyLoader&& addToLikeProperty(id,user._id)}/></span>

                    }
                   {/* <Link to={''} className="mx-2 h5"><i className="fas fa-share-alt"/></Link>*/}
                </div>
                <p><i className="far fa-rupee-sign"/>
                    {property_price ?
                        (property_price >= 10000000) ? (property_price / 10000000).toFixed(2) + ' Cr' : (property_price >= 100000) ? (property_price / 100000).toFixed(2) + ' Lac' : property_price : '0'}
                </p>
            </div>
        </div>

    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    user: state.auth.user,
    isAuthenticated: state.isAuthenticated,
    unlikePropertyLoader: state.property.unlikePropertyLoader,
    likePropertyLoader: state.property.likePropertyLoader,
});

export default connect(mapStateToProps, {addToLikeProperty,addToUnLikeProperty,actionGetAllPropertyList})(
    PropertyListCard
);